import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#collectie", label: "Werk & Meubels" },
  { href: "#rene", label: "Over René" },
  { href: "#werkwijze", label: "Werkwijze" },
  { href: "#werkplaats", label: "Werkplaats Rijswijk" },
  { href: "#beoordelingen", label: "Ervaringen" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[#FBF9F5]/90 backdrop-blur-md border-b border-[#EAE3DA]">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3" data-testid="nav-brand-link">
          <img
            src="/assets/logo.jpg"
            alt="De Houtregisseur logo"
            className="w-16 h-16 rounded-xl object-cover border border-[#E0D5C7] shadow-sm"
          />
          <div>
            <span className="block text-base font-bold tracking-tight text-[#2B231D] font-display">
              DE HOUTREGISSEUR
            </span>
            <span className="block text-[10px] tracking-widest uppercase font-semibold text-[#8C7A6B]">
              Ambacht & Vertrouwd
            </span>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#594E44]">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="hover:text-[#2B231D] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-[#2B231D] text-[#F9F6F0] text-sm font-medium hover:bg-[#43352B] transition-colors shadow-sm"
          >
            Aanvraag Starten
          </a>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label="Menu openen"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg border border-[#EAE3DA] text-[#2B231D]"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-[#EAE3DA] bg-[#FBF9F5] px-6 py-4 flex flex-col gap-4 text-sm font-medium text-[#594E44]">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              className="hover:text-[#2B231D] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-mobile-cta-button"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-[#2B231D] text-[#F9F6F0] text-sm font-medium"
          >
            Aanvraag Starten
          </a>
        </nav>
      )}
    </header>
  );
};
